@import '~style-sheet-helpers/core.less';

.body-inputs {
  display: grid;
  grid-template-columns: 25% 25% 50%;
}
